import React from 'react';
import classNames from 'classnames';
import {Link} from 'react-router-dom';
import Dummy from '../Dummy';
import styles from './style.css';
import {connect} from "react-redux";
import {appScreen} from '../../../lib/redux/actions/app';

class Menu extends Dummy {
    renderItems() {
        return this.props.menuItems.map((item, index) => {
            let menuClass = {}, fault;
            item.fault ? fault = item.fault.value : fault = null;
            menuClass[styles.active] = (this.props.screen === item.name);
            menuClass[styles.avar] = (fault === 1);
            return (
                <Link className={classNames("col-xs-2", menuClass)}
                      id={item.name + 'Menu'}
                      to={`/app/${item.name}`}
                      key={index}
                      onClick={() => this.props.toggleActiveScreen(item.name)}
                >
                    {item.caption}
                </Link>)
        });
    }

    render() {
        const items = this.renderItems();

        return (
            <div className={classNames('row', styles.myMenu)}>
                {items}
            </div>
        )
    }
};

const mapStateToProps = (state, ownProps) => {
    return {'screen': state.appScreen}
};

const mapDispatchToProps = (dispatch) => {
    return {
        toggleActiveScreen: (screen) => dispatch(appScreen(screen))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Menu);


// WEBPACK FOOTER //
// ./src/lib/core/Menu/index.jsx